<template>
    <div class="choose-artist">
        <p class="title">Choose an Artist Page</p>
        <p class="subtitle">
            Choose which artist page you'd like the offer to be made from. You can only choose
            one artist at a time.
        </p>
        <div class="select-wrapper">
            <button
                v-for="(artist, indx) in artistProfiles"
                :style="artist.selected ? { borderColor: '#cdeb09' } : {}"
                @click="() => selectArtist(artist)"
                :key="indx"
                class="artist-page"
            >
                <div class="avatar-wrapper">
                    <img
                        :src="artist.artist_info.avatar"
                        alt="artist-avatar"
                        class="artist-avatar"
                    />
                </div>
                <span class="artist-name">{{ artist.artist_info.band_name }}</span>
            </button>
            <button
                :style="newArtist ? { borderColor: '#cdeb09' } : {}"
                @click="selectNewArtist"
                class="add-new"
            >
                <div class="avatar-wrapper">
                    <img src="/images/icons/plus.svg" alt="plus-icon" class="add-icon" />
                </div>
                <p class="label">A New Artist Page</p>
            </button>
        </div>
    </div>
</template>
<script>
    import { api } from '@/helpers/api'

    export default {
        name: 'ChooseArtist',
        props: {
            artists: {
                type: Array,
                required: false,
                default: () => []
            },
            load: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data: () => ({
            artistProfiles: [],
            newArtist: false
        }),
        watch: {
            newArtist: function (val) {
                if (val) this.createNewAritst()
            },
            artistProfiles: {
                handler: function (profiles) {
                    this.$nextTick(() => {
                        const chosenArtist = profiles.find((profile) => profile.selected)

                        this.$emit('chosen-artist', chosenArtist)
                    })
                },
                deep: true
            }
        },
        emits: ['chosen-artist', 'update:load'],
        methods: {
            selectNewArtist() {
                this.newArtist = !this.newArtist
                this.artistProfiles.forEach((artist) => {
                    artist.selected = false
                })
                if (this.newArtist) {
                    this.$nextTick(() => {
                        this.$emit('chosen-artist', null)
                    })
                }
            },
            selectArtist(artist) {
                this.newArtist = false
                this.artistProfiles.forEach((artist) => {
                    artist.selected = false
                })
                this.$nextTick(() => {
                    artist.selected = true
                    this.$emit('chosen-artist', artist)
                })
            },
            createNewAritst() {
                this.$emit('chosen-artist', null)
            },
            async fetchArtists() {
                try {
                    this.$emit('update:load', true)

                    for (let i = 0; i < this.artists.length; i++) {
                        const artist = this.artists[i]

                        const data = await api({
                            method: 'get',
                            url: `/api/profile/v1/user-profile/profile/artist/${artist.id}`
                        })

                        this.artistProfiles.push({
                            id: data.data.id,
                            artist_info: data.data.info,
                            selected: false,
                            _booking: data.data
                        })
                    }
                } finally {
                    this.$emit('update:load', false)
                }
            }
        },
        async created() {
            if (this.artists.length === 0) this.createNewAritst()
            await this.fetchArtists()
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .choose-artist {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }
        .title {
            padding-bottom: 8px;
            color: #dedede;
            @include base-font-24;
            font-weight: 600;
            line-height: 28px;
        }
        .subtitle {
            padding-bottom: 24px;
            color: #8b8b8b;
            @include base-font-16;
            font-weight: 400;
            line-height: 24px;
        }

        .select-wrapper {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: flex-start;
            gap: 8px;

            .artist-page {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                gap: 8px;
                padding: 4px 16px 4px 4px;
                border-radius: 120px;
                border: 1px solid #464646;
                background: rgba(0, 0, 0, 0);

                .avatar-wrapper {
                    height: 32px;
                    width: 32px;

                    .artist-avatar {
                        height: 32px;
                        width: 32px;
                        object-fit: cover;
                        border-radius: 50%;
                    }
                }
                .artist-name {
                    color: #8b8b8b;
                    @include base-font-16;
                    line-height: 125%;
                    text-transform: capitalize;
                }
            }
            .add-new {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                gap: 8px;
                padding: 10px 16px;
                border-radius: 120px;
                border: 1px solid #8b8b8b;
                background: rgba(0, 0, 0, 0);
            }
            .add-icon {
                height: 20px;
                width: 20px;
                object-fit: cover;
            }
            .label {
                color: #8b8b8b;
                @include base-font-16;
                line-height: 125%;
                text-transform: capitalize;
            }
        }
    }
</style>
